import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Inject, Injector, Input, Output, Signal, TemplateRef, ViewChild, ViewContainerRef, WritableSignal, booleanAttribute, runInInjectionContext, signal } from '@angular/core';
import { InputTextComponent } from '../../inputs/input-text/input-text.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDividerModule } from '@angular/material/divider';
import { Observable, debounceTime, distinctUntilChanged } from 'rxjs';
import { A11yModule } from '@angular/cdk/a11y';
import { MyButtonComponent } from '../../buttons/my-button/my-button.component';
import { TemplatePortal } from '@angular/cdk/portal';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { SidenavComponent } from 'src/app/layout/sidenav/sidenav.component';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { CrudService } from 'src/app/core/services/crud.service';
import { QueryService } from 'src/app/core/services/query.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import { QuerySentrynelService } from 'src/app/core/services/query-sentrynel.service';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    CommonModule,
    A11yModule,
    MatDividerModule,
    MatExpansionModule,
    InputTextComponent,
    MyButtonComponent,
    SidenavComponent,
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent<TData = any> implements AfterViewInit {
  @Input() title: string = 'Seleziona un elemento';
  @Input() crud?: CrudService<TData> | CrudSentrynelService<TData>;
  @Input() query?: QueryService<TData> | QuerySentrynelService<TData>;
  @Input() onInsertFunction?: (args?: any) => Observable<any>;
  @Output() insert: EventEmitter<TData> = new EventEmitter<TData>();

  @ContentChild('body', { static: false }) bodyTemplateRef!: TemplateRef<any>;
  @ContentChild('insertForm', { static: false }) insertFormTemplateRef!: TemplateRef<any>;
  @ViewChild('searchInput') searchInput!: InputTextComponent;
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  searchForm: FormGroup;
  insertForm: FormGroup;
  list?: Signal<TData[]>;
  filteredList: WritableSignal<any[]> = signal([]);

  constructor(
    private _bottomSheetRef: MatBottomSheetRef,
    private readonly fb: FormBuilder,
    private injector: Injector,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
  ) {
    this.searchForm = this.fb.group({
      search: new FormControl(''),
    });
    this.insertForm = this.fb.group({});


    this.initializeSearch();
  }

  ngAfterViewInit(): void {
    if (this.query) {
      this.list = this.query?.list;
      runInInjectionContext(
        this.injector,
        () => {
          if (this.list) {
            toObservable(this.list).subscribe((newList) => {
              this.filteredList.set([]);
              this.filteredList().push(...newList);
            })
          }
        }
      )

    }
    this.filteredList().push(...(this.list ? this.list() : this.data.list));
    setTimeout(() => this.searchInput.myInput.first.focus())
  }

  onClick(item: any) {
    this._bottomSheetRef.dismiss(item);
  }

  initializeSearch() {
    this.searchForm.get('search')?.valueChanges
      .pipe(
        debounceTime(300), // Aggiungi un ritardo prima di applicare il filtro
        distinctUntilChanged() // Filtra solo se il valore cambia rispetto al precedente
      )
      .subscribe((value: string) => {
        this.filteredList.set([]);
        this.filteredList().push(...this.filterList(value || ''));
      });
  }

  filterList(searchTerm: string): any[] {
    // Esegui il filtro sui dati in base al termine di ricerca
    // return this.data.list.filter((item: any) => JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase()));
    return this.list ? this.list().filter((item: any) => JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase())) : this.data.list.filter((item: any) => JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase()));

  }

  trackByIndex = (index: number): number => {
    return index;
  };

  onSaveClick() {
    if (this.insertForm?.valid) {
      this.crud?.save(this.insertForm?.value).subscribe({
        next: (modelValue) => {
          this.insertForm.reset();
          this.accordion.closeAll();
          this.insert.emit(modelValue);
          if (this.onInsertFunction) {
            this.onInsertFunction(modelValue)
          }
          setTimeout(() => {
            this.query?.getAll();
          }, 0);
        }
      });
    }
  }

}
